import { useSelector } from 'react-redux'
import { FormField } from '../../..'
import { FilterSection } from '../FilterSection'
import { defineMessages, useIntl } from 'react-intl'
import { selectFilter } from '../../../../store/selectors/filters'
import { MIN_YEAR_BUILT, MAX_YEAR_BUILT } from '../../../../constants/listings'

import styles from '../Filters.module.scss'

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.listings.filters.constructionYear.heading',
    defaultMessage: 'Construction year'
  },
  min: {
    id: 'General.minimum',
    defaultMessage: 'Minimum'
  },
  max: {
    id: 'General.maximum',
    defaultMessage: 'Maximum'
  }
})

export const ConstructionYear = () => {
  const intl = useIntl()
  const filters = useSelector(selectFilter)

  return (
    <FilterSection title={intl.formatMessage(MSG.heading)}>
      <div className={styles.rangeFields}>
        {/* eslint-disable-next-line */}
        {/* @ts-ignore */}
        <FormField.Year
          placeholder={1776}
          name={MIN_YEAR_BUILT}
          className={styles.rangeField}
          defaultValue={filters[MIN_YEAR_BUILT] || null}
        >
          {intl.formatMessage(MSG.min)}
          {/* eslint-disable-next-line */}
          {/* @ts-ignore */}
        </FormField.Year>
        <div className={styles.dashMark}>—</div>
        {/* eslint-disable-next-line */}
        {/* @ts-ignore */}
        <FormField.Year
          name={MAX_YEAR_BUILT}
          className={styles.rangeField}
          placeholder={new Date().getFullYear()}
          defaultValue={filters[MAX_YEAR_BUILT] || null}
        >
          {intl.formatMessage(MSG.max)}
          {/* eslint-disable-next-line */}
          {/* @ts-ignore */}
        </FormField.Year>
      </div>
    </FilterSection>
  )
}
